<template>
  <v-card
    :style="{
      background: value.sectionColor.backGround,
      color: value.sectionColor.text,
    }"
    class="pa-4"
    tile
  >
    <v-card-title class="section-title pa-2" style="color: inherit !important">
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2" style="color: inherit !important">
      {{ value.description }}
    </v-card-subtitle>

    <v-row no-gutters>
      <v-col
        v-for="({ section }, i) in value.items"
        :key="i"
        class="pa-2"
        cols="12"
      >
        <v-row no-gutters>
          <v-col cols="12">
            <v-img
              v-if="section.object.type === 'image'"
              :aspect-ratio="16 / 9"
              :src="getSrc(section)"
              class="rounded-lg"
              width="100%"
            />
            <iframe v-else :src="section.object.url" style="max-width: 100%" />
          </v-col>

          <v-col cols="12">
            <v-card-title class="px-0 pb-2" v-text="section.title" />
            <pre class="pt-0 px-0 v-card__text" v-html="section.text" />
            <v-card-actions
              v-if="Object.keys(section.button).length > 0"
              :class="{ 'justify-end': section.text_position === 'left' }"
              class="px-0"
            >
              <v-btn
                v-if="section.button.show"
                :href="getLink(section.button.link)"
                :style="{
                  background: section.button.background,
                  color: section.button.color,
                }"
                :target="section.button.target || '_blank'"
              >
                <v-icon
                  :color="section.button.color"
                  left
                  v-text="section.button.icon"
                />
                {{ section.button.title }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "bSectionView",

  props: {
    value: Object,
  },

  methods: {
    getLink(input) {
      let link = "";
      if (!!input && !input.startsWith("http")) {
        link = "https://";
      }

      return link + input;
    },
    getSrc(sec) {
      const src = sec.object.url;
      return typeof src === "string"
        ? src
        : !!src[0] && !!src[0].images && !!src[0].images.length > 0
        ? src[0].images[0].url
        : "";
    },
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}
</style>
